module.exports = __webpack_public_path__ + "static/media/session2grayscale.0af586f6.svg";